import type { SectionLocale } from '../types'

export const METRICS_LOCALE: SectionLocale = [
  [
    'metrics_wallet',
    {
      ru: 'Текущий баланс кошельков',
      en: 'Current Wallet Balances',
    },
  ],
  [
    'metrics_transfer_balance',
    {
      ru: 'Добавленные монеты для передачи',
      en: 'Transfer coins added',
    },
  ],
  [
    'metrics_transfer_balance_description',
    {
      ru: 'Показывает добавленные в систему монеты для передачи в разрезе по месяцам. Зависит от количества пользователей и от того, насколько активно пользователи переводили монеты в предыдущем месяце. Чем больше монет добавлено, тем больше должен быть бюджет на магазин',
      en: 'Shows the active coins added to the system by month. Depends on the number of users and on how actively users transferred coins in the previous month. The more coins added, the larger should be the budget for the store',
    },
  ],
  [
    'metrics_users_balance',
    {
      ru: 'Баланс кошельков пользователей',
      en: 'Wallet Balances of Users',
    },
  ],
  [
    'metrics_users_balance_description',
    {
      ru: 'Показывает количество монет, которые пользователи могут потратить в магазине, в разрезе по пользователям. Не включает заблокированных пользователей.',
      en: 'Shows the amount of coins that users can spend in the store per user. Does not include blocked users.',
    },
  ],
  [
    'metrics_spend_coins',
    {
      ru: 'Потраченные монеты',
      en: 'Wallets spent coins',
    },
  ],
  [
    'metrics_spend_coins_description',
    {
      ru: 'Показывает количество монет, которые пользователи потратили в магазине в разрезе по месяцам. Позволяет прогнозировать реальный бюджет на магазин на месяц',
      en: 'Shows the number of coins that users have spent in the store broken down by month. Allows you to forecast the real budget for the store for a month',
    },
  ],
  [
    'metrics_usable_avarage_per_month',
    {
      ru: 'Среднее количество монет на счету по месяцам',
      en: 'Usable avarage coins count per month',
    },
  ],
  [
    'metrics_usable_avarage_per_month_description',
    {
      ru: 'Показывает среднее количество монет, которые пользователи имеют на счету кошелька в разрезе по месяцам. Помогает понять, накапливаются ли монеты (риск скачков расходов в будущем) или постоянно расходуются (cтабилизации расходов). Косвенно показывает, интересные ли товары представлены в магазине. Не учитывает монеты заблокированных пользователей.',
      en: 'Shows the average number of coins users have in their usable account by month. Helps to understand whether coins are accumulated (risk of future spending spikes) or constantly spent (stabilization of spending). Indirectly shows whether interesting or not products are presented in the store. Does not count coins of blocked users.',
    },
  ],
  [
    'metrics_user_engagement_per_month',
    {
      ru: 'Активность пользователей по месяцам',
      en: 'User engagement per month',
    },
  ],
  [
    'metrics_user_engagement_per_month_description',
    {
      ru: 'Показывает количество пользователей, которые совершили покупку или перевод в разрезе по месяцам. Позволяет понять активность использования системы поощрений и динамику этой активности.',
      en: 'Shows the number of users who have made a purchase or transfer by month. Allows you to understand the activity of using the rewards system and the dynamics of this activity.',
    },
  ],
  [
    'metrics_transfer_stats_per_month',
    {
      ru: 'Статистика переводов по месяцам',
      en: 'Transfer stats per month',
    },
  ],
  [
    'metrics_transfer_stats_per_month_description',
    {
      ru: 'Показывает количество переводов и среднюю сумму переводов в разрезе по месяцам. Позволяет понять, насколько активно пользователи благодарят друг друга, и в каком количестве.',
      en: 'Shows the number of transfers and the average amount of transfers by month. Allows you to understand how actively users thank each other and in what amount.',
    },
  ],
  [
    'metrics_table__month',
    {
      ru: 'Месяц',
      en: 'Month',
    },
  ],
  [
    'metrics_table__transfer_coins',
    {
      ru: 'Монеты для передачи',
      en: 'Transfer coins',
    },
  ],
  [
    'metrics_table__user',
    {
      ru: 'Пользователь',
      en: 'User',
    },
  ],
  [
    'metrics_table__user_count',
    {
      ru: 'Количество пользователей',
      en: 'User count',
    },
  ],
  [
    'metrics_table__transfer_count',
    {
      ru: 'Количество переводов',
      en: 'Transfer count',
    },
  ],
  [
    'metrics_table__wallet_coins',
    {
      ru: 'Монеты кошелька',
      en: 'Wallet coins',
    },
  ],
  [
    'metrics_table__total',
    {
      ru: 'Итого',
      en: 'Total',
    },
  ],
  [
    'metrics_table__average_value',
    {
      ru: 'Среднее значение',
      en: 'Average value',
    },
  ],
]
